import { render } from "./PushProcessingDetail.vue?vue&type=template&id=2a1b9b45&scoped=true&ts=true&lang=pug"
import script from "./PushProcessingDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./PushProcessingDetail.vue?vue&type=script&setup=true&lang=ts"

import "./PushProcessingDetail.vue?vue&type=style&index=0&id=2a1b9b45&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a1b9b45"]])

export default __exports__